import { render } from "./GuestDeleteAgree.vue?vue&type=template&id=595f0ab0"
import script from "./GuestDeleteAgree.vue?vue&type=script&lang=js"
export * from "./GuestDeleteAgree.vue?vue&type=script&lang=js"

import exportComponent from "/home/milu/Projects/tesco-csapatnap/csapatnap.hu-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__